import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeDirective } from './theme.directive';
import { THEMES, ACTIVE_THEME, ThemeOptions } from './theme.interface';
@NgModule({
    imports: [CommonModule],
    declarations: [ThemeDirective],
    exports: [ThemeDirective],
})
export class ThemeModule {
    static forRoot(options: ThemeOptions): any {
        return {
            ngModule: ThemeModule,
            providers: [
                {
                    provide: THEMES,
                    useValue: options.themes,
                },
                {
                    provide: ACTIVE_THEME,
                    useValue: options.active,
                },
            ],
        };
    }
}
